import React from 'react';
import { Navigate } from 'react-router-dom';

interface AdminRouteGuardProps {
  children: React.ReactNode;
}

const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({ children }) => {
  const adminToken = localStorage.getItem('adminToken');

  if (!adminToken) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default AdminRouteGuard;
